module.exports = __webpack_public_path__ + "static/media/Bottom_Building_Dark.f5ec71f5.png";